module.exports = __webpack_public_path__ + "img/close.0c55fd69.png";